export const platformAppName = 'Platform'
export const requestManagement = 'Request Management'
export const mobilityAppName = 'Mobility'

export enum UserType {
  customerUser = 'customer_user',
  staffUser = 'staff_user',
}
